<template lang="pug">
  div.wrap-module-visualization
    NowLoading(:show="!isInizialized")
    img(v-if="!isInizialized" ref="firstPageImg"
      :src="pages[0].imgURL").page
    div.wrap-canvas
      div(ref="wrapper").wrapper
        h1(ref="test" style="color: #999;") Class Jack
        div(v-for="item in pageObjects" :ref="item.id").page
          img(:src="item.imgURL").object-fit-cover
        div(v-for="item in doodleObjects" :ref="item.id").wrap-doodle
          ItemDoodleText(v-if="item.type === 'text'" :doodle="item")
          ItemDoodleImage(v-if="item.type === 'image'" :doodle="item")
        //- div(v-for="item in doodleObjects").doodle
          div(v-if="item.type === 'text'")
            span {{item.value}}
          div(v-if="item.type === 'image'")
            img(:src="item.imgURL").object-fit-cover
        div(v-for="item in messageObjects"
          :ref="item.id").wrap-message
          ItemMessageText(v-if="item.class === 'message'" :message="item")
          ItemMessageEmort(v-if="item.class === 'sound'" :message="item")
    div.wrap-slider.f.fc
      div.slider
        v-slider(v-model="pixelPerSecond"
          :color="pallete.$active_color"
          min="0" max="30" step="0.001")
        //- v-slider(v-model="cameraDistance"
          :color="pallete.$active_color"
          min="0" max="100" step="0.2")
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-module-visualization {
  position: relative;
  .page {
    opacity: 0.8;
  }
  .wrap-canvas {
    .wrapper {
      width: 100%;
      min-height: 100vh;
      padding: 0;
      background: #000;
    }
  }
  .wrap-slider {
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 0;
    .slider {
      width: 90%;
      max-width: 620px;
    }
  }
}
</style>

<script>
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import CSS3DRenderer from 'three-css3drenderer'
import { differenceInSeconds, differenceInMinutes, add } from 'date-fns'
import NowLoading from '@/components/shared/NowLoading'
import ItemDoodleText from '@/components/item/Visualization/ItemDoodleText'
import ItemDoodleImage from '@/components/item/Visualization/ItemDoodleImage'
import ItemMessageText from '@/components/item/Visualization/ItemMessageText'
import ItemMessageEmort from '@/components/item/Visualization/ItemMessageEmort'

export default {
  components: {
    NowLoading,
    ItemDoodleText,
    ItemDoodleImage,
    ItemMessageText,
    ItemMessageEmort
  },
  props: {
    slide: {
      type: Object,
      required: true
    },
    pages: {
      type: Array,
      required: true
    },
    doodles: {
      type: Array,
      required: true
    },
    messages: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      isInizialized: false,
      renderer: null,
      scene: null,
      camera: null,
      // cameraPos: [0, 0, 1600],
      cameraPos: [0, 0, 100],
      controls: null,
      pageObjects: [],
      doodleObjects: [],
      messageObjects: [],
      allGroup: null,
      pageGroup: null,
      doodleGroup: null,
      messageGroup: null,
      pixelPerSecond: 10,
      pageSize: null,
      initializeTimer: null,
      averageCreationTime: null,
      // for auto rotation
      pixelPerSecondRange: [0, 100],
      pixelPerSecondStep: 0.01,
      scalingUp: true,
      // for auto zoom
      cameraDistance: 30
    }
  },
  computed: {
    oldestDoodleCreatedAt () {
      return this.doodles[0] ? this.doodles[0].createdAt.toDate() : new Date()
    },
    latestDoodleCreatedAt () {
      return this.doodles[0] ? this.doodles[this.doodles.length - 1].createdAt.toDate() : new Date()
    }
  },
  watch: {
    pixelPerSecond () {
      this.updatePosByPixelPerSecond()
    },
    cameraDistance () {
      this.updateCameraPosByAutoZoom()
    }
  },
  created () {
    // 落書きとメッセージの平均のを取得作成日時
    const doodleCreationTimes = this.doodles.map(d => d.createdAt.toDate().getTime())
    const messagesCreationTimes = this.messages.map(d => d.createdAt.toDate().getTime())
    const allObjCreationTimes = doodleCreationTimes.concat(messagesCreationTimes)
    const allTimesSum = allObjCreationTimes.reduce((sum, element) => sum + element, 0)
    this.averageCreationTime = new Date(allTimesSum / allObjCreationTimes.length)
  },
  async mounted () {
    // const imgElem = document.createElement('img')
    // imgElem.src = this.pages[0].imgURL
    await this.sleep(1000)

    const imgElem = this.$refs.firstPageImg
    this.pageSize = { w: imgElem.width, h: imgElem.height }
    
    this.doodleObjects = this.doodles.filter(d => {
        // 平均作成時間より120分よりズレている落書きは削除
        const differenceMin = differenceInMinutes(d.createdAt.toDate(), this.averageCreationTime)
        return Math.abs(differenceMin) <= 120
      }).map(d => {
        const x = this.pageSize.w * (d.left / 100) - this.pageSize.w / 2
        const y = this.pageSize.h * (d.top / 100) - this.pageSize.h / 2
        d.pos = [x, y, this.convertTimeToZSpace(d.createdAt.toDate())]
        return d
      })

    this.messageObjects = this.messages.filter(m => {
      // 平均作成時間より120分よりズレているメッセージは削除
      const differenceMin = differenceInMinutes(m.createdAt.toDate(), this.averageCreationTime)
      return Math.abs(differenceMin) <= 120
    }).map(m => {
      const x = this.pageSize.w * (m.createdFrom.x / 100) - this.pageSize.w / 2
      const y = this.pageSize.h * (m.createdFrom.y / 100) - this.pageSize.h / 2
      m.pos = [x, y, this.convertTimeToZSpace(m.createdAt.toDate())]
      return m
    })

    this.pageObjects = this.pages.filter(p => {
      // doodleがあるスライドだけ抽出
      const doodlesInPage = this.doodles.filter(d => d.page === p.id)
      return doodlesInPage[0] ? true : false
    }).map((p, index) => {
      const doodlesInPage = this.doodles.filter(d => d.page === p.id)
      // ページ内に落書きが一つもなかった場合の処理
      if (!doodlesInPage[0] && index === 0) {
        p.latestDoodleTime = 0
        p.oldestDoodleTime = 0
        p.pos = [0, 0, 0]
        return p
      } else if (!doodlesInPage[0] && index > 0) {
        p.latestDoodleTime = add(this.pages[index - 1].latestDoodleTime, { minutes: 10 })
        p.oldestDoodleTime = this.pages[index - 1].oldestDoodleTime
        p.pos = [0, 0, this.convertTimeToZSpace(p.oldestDoodleTime)]
        return p
      }
      p.latestDoodleTime = doodlesInPage[0].createdAt.toDate()
      p.oldestDoodleTime = doodlesInPage[doodlesInPage.length - 1].createdAt.toDate()
      p.pos = [0, 0, this.convertTimeToZSpace(p.oldestDoodleTime)]
      // p.pos = [0, 0, 0]
      return p
    })

    this.init()
  },
  methods: {
    init () {
      if (!this.doodleObjects[0]) {
        alert('このスライドは可視化できません')
        this.$router.push('/')
        return
      }
      // 最後の要素のロードが終わるまで1秒間隔で呼び出す
      const lastDoodleId = this.doodleObjects[this.doodleObjects.length - 1].id
      if (!this.$refs[lastDoodleId]) {
        setTimeout(this.init, 1000)
        return
      }
      console.log('this.doodles:', this.doodles)

      this.scene = new THREE.Scene()
      this.scene.background = new THREE.Color(0x000000)

      // ライトの設定
      const light = new THREE.DirectionalLight(0xffffff)
      light.position.set(1, 10, 1).normalize()
      this.scene.add(light)

      // 座標軸を表示
      const axesHelper = new THREE.AxesHelper(0.5)
      this.scene.add(axesHelper)

      // CSS3DObject
      // const gridElems = this.$refs.grid
      // let shapes = new THREE.Group()
      // for (let i=0; i < gridElems.length; i++) {
      //   // const object = new CSS3DRenderer.CSS3DObject(gridElems[i])
      //   const object = new CSS3DRenderer.CSS3DSprite(gridElems[i])
      //   object.position.fromArray(this.posts[i].position)
      //   object.rotation.fromArray([0, 0, 0])
      //   shapes.add(object)
      // }
      // this.scene.add(shapes)

      // this.allGroup = new THREE.Group()

      // const midPos = new THREE.Vector3().lerpVectors(
      //   this.doodles[0].obj.position,
      //   this.doodles[this.doodles.length - 1].obj.position,
      //   0.5
      // )
      // console.log('midPos:', { ...midPos })
      // this.allGroup.position = midPos

      // this.allGroup.position.set(0, 0, this.pageObjects[this.pageObjects.length - 1].pos[2])
      // console.log('midPos:', { ...this.allGroup.position })

      this.pageGroup = new THREE.Group()
      for (let i=0; i < this.pageObjects.length; i++) {
        const elem = this.$refs[this.pageObjects[i].id][0]
        if (!elem) continue
        const obj = new CSS3DRenderer.CSS3DObject(elem)
        obj.position.fromArray(this.pageObjects[i].pos)
        this.pageObjects[i].obj = obj
        this.pageGroup.add(obj)

        // this.allGroup.add(obj)
      }
      this.scene.add(this.pageGroup)

      this.doodleGroup = new THREE.Group()
      for (let i=0; i < this.doodleObjects.length; i++) {
        const elem = this.$refs[this.doodleObjects[i].id][0]
        if (!elem) continue
        const obj = new CSS3DRenderer.CSS3DSprite(elem)
        obj.position.fromArray(this.doodleObjects[i].pos)
        this.doodleObjects[i].obj = obj
        this.doodleGroup.add(obj)

        // this.allGroup.add(obj)
      }
      this.scene.add(this.doodleGroup)

      this.messageGroup = new THREE.Group()
      for (let i=0; i < this.messageObjects.length; i++) {
        const elem = this.$refs[this.messageObjects[i].id][0]
        if (!elem) continue
        const obj = new CSS3DRenderer.CSS3DSprite(elem)
        obj.position.fromArray(this.messageObjects[i].pos)
        this.messageObjects[i].obj = obj
        this.messageGroup.add(obj)

        // this.allGroup.add(obj)
      }
      this.scene.add(this.messageGroup)

      // this.scene.add(this.allGroup)

      // const testObj = new CSS3DRenderer.CSS3DSprite(this.$refs.test)
      // // const testObj = new CSS3DRenderer.CSS3DObject(this.$refs.test)
      // testObj.position.fromArray([0, 0, 0])
      // this.scene.add(testObj)

      // CSS3DRenderer
      const canvasElem = this.$refs.wrapper
      this.renderer = new CSS3DRenderer.CSS3DRenderer()
      this.renderer.setSize(canvasElem.clientWidth, canvasElem.clientHeight)
      while (canvasElem.firstChild) canvasElem.removeChild(canvasElem.firstChild)
      canvasElem.appendChild(this.renderer.domElement)

      // カメラの設定
      this.camera = new THREE
        .PerspectiveCamera(35, window.innerWidth / window.innerHeight, 0.1, 1000)
      this.camera.position.fromArray(this.cameraPos)

      // カメラコントーロールの設定
      this.controls = new OrbitControls(this.camera, this.renderer.domElement)
      this.controls.zoomSpeed = 0.1
      // controls.target.set(0, 0, -10000)

      // for auto rotation
      // this.controls.autoRotate = true
      // this.controls.target.set(0, 0, this.pageObjects[Math.floor(this.pageObjects.length / 2)].pos[2])
      // hide for auto rotation
      this.controls.target.set(0, 0, this.pageObjects[this.pageObjects.length - 1].pos[2])

      this.controls.screenSpacePanning = true
      this.controls.update()

      // アニメーションを開始
      this.tick()

      this.isInizialized = true
    },
    tick () {
      // const midPos = new THREE.Vector3().lerpVectors(
      //   this.doodles[0].obj.position,
      //   this.doodles[this.doodles.length - 1].obj.position,
      //   0.5
      // )
      // this.pageGroup.position = midPos
      // this.doodleGroup.position = midPos
      // this.messageGroup.position = midPos

      // this.pageGroup.rotation.y = this.pageGroup.rotation.y + 0.001
      // this.doodleGroup.rotation.y = this.doodleGroup.rotation.y + 0.001
      // this.messageGroup.rotation.y = this.messageGroup.rotation.y + 0.001

      // this.allGroup.rotation.y += 0.001
      // this.allGroup.scale = this.allGroup.scale.addScalar(0.01)

      // for auto rotation
      // this.camera.position.set(0, 0, 1600)

      // if (this.scalingUp) {
      //   this.pixelPerSecond += this.pixelPerSecondStep
      // } else {
      //   this.pixelPerSecond -= this.pixelPerSecondStep
      // }
      // if (this.pixelPerSecond >= 10) {
      //   this.scalingUp = false
      // } else if (this.pixelPerSecond <= 0) {
      //   this.scalingUp = true
      // }
      // console.log('this.pixelPerSecond:', this.pixelPerSecond)

      for (let i=0; i < this.pageObjects.length; i++) {
        const doodlesInPage = this.doodles.filter(d => d.page === this.pageObjects[i].id)
        this.pageObjects[i].pos[2] = this.convertTimeToZSpace(this.pageObjects[i].oldestDoodleTime)
        this.pageObjects[i].obj.position.fromArray(this.pageObjects[i].pos)
      }
      for (let i=0; i < this.doodleObjects.length; i++) {
        this.doodleObjects[i].pos[2] = this.convertTimeToZSpace(this.doodleObjects[i].createdAt.toDate())
        this.doodleObjects[i].obj.position.fromArray(this.doodleObjects[i].pos)
      }
      for (let i=0; i < this.messageObjects.length; i++) {
        this.messageObjects[i].pos[2] = this.convertTimeToZSpace(this.messageObjects[i].createdAt.toDate())
        this.messageObjects[i].obj.position.fromArray(this.messageObjects[i].pos)
      }

      this.controls.update()
      requestAnimationFrame(this.tick)
      this.renderer.render(this.scene, this.camera)
    },
    updatePosByPixelPerSecond () {
      for (let i=0; i < this.pageObjects.length; i++) {
        const doodlesInPage = this.doodles.filter(d => d.page === this.pageObjects[i].id)
        this.pageObjects[i].pos[2] = this.convertTimeToZSpace(this.pageObjects[i].oldestDoodleTime)
        this.pageObjects[i].obj.position.fromArray(this.pageObjects[i].pos)
      }
      for (let i=0; i < this.doodleObjects.length; i++) {
        this.doodleObjects[i].pos[2] = this.convertTimeToZSpace(this.doodleObjects[i].createdAt.toDate())
        this.doodleObjects[i].obj.position.fromArray(this.doodleObjects[i].pos)
      }
      for (let i=0; i < this.messageObjects.length; i++) {
        this.messageObjects[i].pos[2] = this.convertTimeToZSpace(this.messageObjects[i].createdAt.toDate())
        this.messageObjects[i].obj.position.fromArray(this.messageObjects[i].pos)
      }

      this.controls.target.set(0, 0, this.pageObjects[this.pageObjects.length - 1].pos[2])
    },
    updateCameraPosByAutoZoom () {
      // this.camera.position = new THREE.Vector3().lerpVectors(
      //   // this.camera.position,
      //   new THREE.Vector3().fromArray(this.cameraPos),
      //   this.controls.target,
      //   this.cameraDistance / 1000
      // )
      // // this.camera.position = new THREE.Vector3().lerp(
      // //   // this.camera.position,
      // //   // new THREE.Vector3().fromArray(this.cameraPos),
      // //   this.controls.target,
      // //   this.cameraDistance / 100
      // // )
      // console.log({ ...this.camera.position })

      //  this.camera.position =  this.camera.position.addScalar(-this.cameraDistance)

      // this.camera.zoom = this.cameraDistance
      // console.log('this.camera.zoom', this.camera.zoom)
      // console.log('this.camera.position', this.camera.position)

      // this.controls.target.set(0, 0, -this.cameraDistance * 100)
      // this.controls.update()

      // this.controls.maxZoom = this.cameraDistance
      // this.controls.update()

      // (x,y,z)=(x1,y1,z1)+t(x2-x1,y2-y1,z2-z1)
      // const p1 = this.camera.position
      // const p2 = this.controls.target
      // const pp = new THREE.Vector3(p2.x-p1.x, p2.y-p1.y, p2.z-p1.z)
      // const tpp = pp.multiplyScalar(this.cameraDistance)

      // const newPos = p1.add(tpp)
      // this.camera.position.set(newPos.x, newPos.y, newPos.z)
      // console.log('this.camera.position:', this.camera.position)

      // this.controls.zoom0 = this.cameraDistance

      // // const zoomDistance = Number(zoomer.value)
      // const zoomDistance = Number(this.cameraDistance)
      // const currDistance = this.camera.position.length()
      // const factor = zoomDistance/currDistance

      // this.camera.position.x *= factor
      // this.camera.position.y *= factor
      // this.camera.position.z *= factor
    },
    convertTimeToZSpace (time) {
      if (time === 0) return 0
      return differenceInSeconds(this.oldestDoodleCreatedAt, time) * this.pixelPerSecond
    }
  }
}
</script>
